import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ProfileService } from '@core/services/profile/profile.service';
import { forkJoin, Observable } from 'rxjs';

@Injectable({
    providedIn: "root"
})
export class ProfilesResolver implements Resolve<any> {

    constructor(
        private _profileService: ProfileService,
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        return forkJoin([
            this._profileService.getAll(),
            this._profileService.getAllPermissions()
        ]);
    }
}